import { connect } from "react-redux";
import get from "lodash/get";

import {
  getRetranslations as onGetRetranslations,
  getRetranslationsTypes as onGetRetranslationsTypes,
  createRetranslationUnit as onCreateRetranslationUnit,
  deleteRetranslationUnit as onDeleteRetranslationUnit,
} from "../../actions/retranslationsActions";

const mapStateToProps = (state) => ({
  retranslationsDataState: state.retranslations.retranslationsDataState,
  retranslationsTypesDataState: state.retranslations.retranslationsTypesDataState,
  createRetranslationUnitTypesDataState: state.retranslations.createRetranslationUnitTypesDataState,
  deleteRetranslationUnitTypesDataState: state.retranslations.deleteRetranslationUnitTypesDataState,
  retranslations: get(state, ["retranslations", "retranslations"], []),
  retranslationsTypes: get(state, ["retranslations", "retranslationsTypes"], []),
  errors: get(state, ["retranslations", "errors"], []),
});

const mapDispatchToProps = { onGetRetranslations, onGetRetranslationsTypes, onCreateRetranslationUnit, onDeleteRetranslationUnit };

const withRetranslations = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRetranslations };
